import z from 'zod';

import { PlateParagraph } from './Paragraph';
import { ELEMENT_TYPES } from '../constants';

export const Caption = z.object({
    ...PlateParagraph.shape,
    type: z.literal(ELEMENT_TYPES.CAPTION),
});
export type CaptionElement = z.infer<typeof Caption>;
